// Mock data for BeauClean website

export const beforeAfterImages = [
  {
    id: 1,
    before: "https://customer-assets.emergentagent.com/job_car-detailing-pro-13/artifacts/seswftg4_IMG_5383.JPG",
    after: "https://customer-assets.emergentagent.com/job_car-detailing-pro-13/artifacts/seswftg4_IMG_5383.JPG",
    title: "Transformation Complète",
    description: "Intérieur profondément nettoyé"
  },
  {
    id: 2,
    before: "https://customer-assets.emergentagent.com/job_car-detailing-pro-13/artifacts/9i2mmxtk_IMG_5382.JPG",
    after: "https://customer-assets.emergentagent.com/job_car-detailing-pro-13/artifacts/9i2mmxtk_IMG_5382.JPG",
    title: "Sièges Avant Rénovés",
    description: "Shampoing et nettoyage en profondeur"
  },
  {
    id: 3,
    before: "https://customer-assets.emergentagent.com/job_car-detailing-pro-13/artifacts/2eduy51u_IMG_5381.JPG",
    after: "https://customer-assets.emergentagent.com/job_car-detailing-pro-13/artifacts/2eduy51u_IMG_5381.JPG",
    title: "Tapis et Moquette",
    description: "Élimination des saletés incrustées"
  },
  {
    id: 4,
    before: "https://customer-assets.emergentagent.com/job_car-detailing-pro-13/artifacts/l6rjzygg_IMG_5380.JPG",
    after: "https://customer-assets.emergentagent.com/job_car-detailing-pro-13/artifacts/l6rjzygg_IMG_5380.JPG",
    title: "Habitacle Intérieur",
    description: "Résultat impeccable et professionnel"
  },
  {
    id: 5,
    before: "https://customer-assets.emergentagent.com/job_car-detailing-pro-13/artifacts/58k3teee_IMG_5379.JPG",
    after: "https://customer-assets.emergentagent.com/job_car-detailing-pro-13/artifacts/58k3teee_IMG_5379.JPG",
    title: "Sièges Arrière",
    description: "Nettoyage des taches et débris"
  },
  {
    id: 6,
    before: "https://customer-assets.emergentagent.com/job_car-detailing-pro-13/artifacts/u8kabalh_IMG_5377.JPG",
    after: "https://customer-assets.emergentagent.com/job_car-detailing-pro-13/artifacts/u8kabalh_IMG_5377.JPG",
    title: "Coffre Impeccable",
    description: "Du chaos absolu à la propreté parfaite"
  }
];

export const logo = "https://customer-assets.emergentagent.com/job_car-detailing-pro-13/artifacts/9ya7cj5m_414487052_122099686172174913_3735285075994030322_n.jpg";

export const services = [
  {
    id: 1,
    name: "L'Essentiel",
    price: "49€",
    description: "Nettoyage intérieur express pour redonner de la propreté à votre véhicule",
    features: [
      "Aspiration complète",
      "Dépoussiérage",
      "Nettoyage des plastiques",
      "Finition plastiques (protection UV + brillance)",
      "Vitres intérieures"
    ],
    popular: false
  },
  {
    id: 2,
    name: "Le Shampoing",
    price: "89€",
    description: "Nettoyage intérieur en profondeur avec shampoing des sièges et des textiles",
    features: [
      "Tout de L'Essentiel",
      "Shampoing des sièges",
      "Shampoing des textiles",
      "Shampoing des tapis, moquettes et coffre",
      "Finition plastiques (protection UV + brillance)",
      "Rafraîchissement de l'habitacle",
      "Amélioration du rendu global"
    ],
    popular: true
  },
  {
    id: 3,
    name: "Le Premium",
    price: "129€",
    basePrice: 129,
    description: "Prestation complète pour véhicules très sales avec traitement approfondi",
    features: [
      "Tout du Shampoing",
      "Shampoing des tapis, moquettes et coffre",
      "Traitement des taches tenaces",
      "Élimination des poils d'animaux (coffre)",
      "Traitement sable important (coffre)",
      "Finition plastiques (protection UV + brillance)",
      "Résultat très approfondi",
      "Désinfection de l'habitacle"
    ],
    supplements: [
      {
        name: "Poils d'animaux sur moquettes et tapis",
        price: "+30€",
        description: "Si présence de poils d'animaux sur les moquettes et tapis de l'habitacle (hors coffre)"
      },
      {
        name: "Sable sur toutes les moquettes et tapis",
        price: "+30€",
        description: "Si sable important sur toutes les moquettes et tapis de l'habitacle"
      }
    ],
    popular: false
  },
  {
    id: 4,
    name: "Nettoyage Extérieur",
    price: "29€",
    badge: "Nouveau !",
    badgeColor: "bg-green-500",
    description: "Lavage extérieur professionnel à la main avec produits premium",
    features: [
      "Pré-lavage soigneux",
      "Lavage à la main",
      "Produits de qualité professionnelle",
      "Nettoyage des jantes",
      "Séchage microfibre",
      "Finition impeccable"
    ],
    note: "Peut être combiné avec n'importe quelle formule intérieure",
    popular: false
  }
];

export const businessHours = {
  weekdays: {
    days: "Lundi à Samedi",
    hours: "8h - 20h"
  },
  closed: "Fermé le Dimanche"
};

export const whatsappLink = "https://wa.me/message/IXHEYFEAVDH3A1";

export const phoneNumber = "06 65 97 68 64";
export const phoneLink = "tel:+33665976864";

export const serviceArea = {
  city: "Bordeaux",
  radius: "40 km",
  description: "Service de nettoyage automobile à domicile"
};

export const testimonials = [
  {
    id: 1,
    name: "Marie L.",
    location: "Bordeaux",
    rating: 5,
    text: "Excellent service ! Mon intérieur était dans un état déplorable et maintenant il est comme neuf. Service à domicile très pratique."
  },
  {
    id: 2,
    name: "Thomas D.",
    location: "Mérignac",
    rating: 5,
    text: "Très professionnel, ponctuel et le résultat est impressionnant. Je recommande vivement BeauClean !"
  },
  {
    id: 3,
    name: "Sophie M.",
    location: "Pessac",
    rating: 5,
    text: "Super prestation ! Les sièges sont impeccables et l'odeur est agréable. Prix très correct pour la qualité du travail."
  }
];

export const benefits = [
  {
    id: 1,
    title: "Service à Domicile",
    description: "Nous venons directement chez vous, au travail ou ailleurs dans Bordeaux et 40km autour"
  },
  {
    id: 2,
    title: "Résultats Garantis",
    description: "Des transformations spectaculaires avec des produits professionnels de qualité"
  },
  {
    id: 3,
    title: "Rapidité & Efficacité",
    description: "Intervention rapide et efficace sans compromettre la qualité du résultat"
  },
  {
    id: 4,
    title: "Prix Transparents",
    description: "Tarifs clairs et fixes, sans surprise ni frais cachés"
  }
];
